import type { GridConfig } from 'liyu-pc-base/typing';

export default ({ menu_flag }): GridConfig => {
  return {
    isDraggable: false,
    isResizable: false,
    itemPadding: '2px',
    items: [
      {
        key: 'layout001',
        layout: {
          x: '0px',
          y: '0px',
          w: '30%',
          h: '100px',
        },
        component: '',
      },
      {
        key: 'layout002',
        layout: {
          x: '30%',
          y: '0px',
          w: '30%',
          h: '100px',
        },
        component: '',
      },
    ],
  };
};
